import { AppwriteException } from 'appwrite';
import { QueryClient } from '@tanstack/react-query';

/**
 * One cache for the whole app.
 *
 * Retrying a 401/403 is pointless — the session is gone, and the auth layer,
 * not the query layer, is what recovers from that.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof AppwriteException) {
          if (error.code === 401 || error.code === 403 || error.code === 404) return false;
        }
        return failureCount < 2;
      },
    },
  },
});
